import React, { useEffect } from "react";
import Content from "./components/content";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: "'ShruitFont', sans-serif;",
  },
});

const RedirectToHomeLocation = () => {
  useEffect(() => {
    
    window.location.href = "https://maps.app.goo.gl/piwf9ZyW73FJ778R6";
  }, []);
  return null;
};

const RedirectToLaganLocation = () => {
  useEffect(() => {
    window.location.href = "https://maps.app.goo.gl/8gZBohaBnff5u8E78";
  }, []);
  return null;
};

const RedirectToLagan = () => {
  useEffect(() => {
    window.location.href = window.location.origin + "/lagan";
  }, []);
  return null;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          {/* Main Content Route */}
          <Route exact path="/"element={<RedirectToLagan />} />
          <Route exact path="/lagan" element={<Content />} />

          {/* Redirection Routes */}
          <Route exact path="/home/location" element={<RedirectToHomeLocation />} />
          <Route exact path="/lagan/location" element={<RedirectToLaganLocation />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
